import Joi from "joi";

const schema = Joi.object({
  code_type: Joi.string().required().messages({
    "string.empty": "Harap mengisi Tipe user",
  }),
  department: Joi.string().required().messages({
    "string.empty": "Harap mengisi Departemen",
  }),
  department_desc: Joi.string().required().messages({
    "string.empty": "Harap mengisi Deskripsi",
  }),
  department_cost: Joi.string().required().messages({
    "string.empty": "Harap mengisi Departemen cost",
  }),
});

export default schema;
